/**用户token */
export const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN_KEY';
/**续token */
export const REFRESH_TOKEN_KEY = 'REFRESH_TOKEN_KEY';
/**过期时间 */
export const EXPIRATION_TIME = 'EXPIRATION_TIME';
/**租户 */
export const TENANT_ID_KEY = 'TENANT_ID_KEY';
/** 租户应用 */
export const APPLICATION_INFO_KEY = 'APPLICATION_INFO_KEY';
/** 管理员应用 */
export const ADMIN_APPLICATION_INFO_KEY = 'ADMIN_APPLICATION_INFO_KEY';
/** 应用前缀集合 */
export const APP_PATHNAME_LIST_KEY = 'APP_PATHNAME_LIST_KEY';
/**历史记录 */
export const HISTORY_URL_KEY = 'HISTORY_URL_KEY';
/**用户信息 */
export const USER_NAME_KEY = 'USER_NAME_KEY';
/**仓库信息 */
export const WAREHOUSE_INFO_KEY = 'WAREHOUSE_INFO_KEY';
/**卖家信息 */
export const VENDOR_INFO_KEY = 'VENDOR_INFO_KEY';
/** 客户信息 */
export const CUSTOMER_INFO_KEY = 'CUSTOMER_INFO_KEY';
/** 是否开启语音 */
export const VOICE_KEY = 'VOICE_KEY';
/** 最后一次请求的时间 */
export const LAST_REQUEST_KEY = 'LAST_REQUEST_KEY';
/** 用户登录信息 */
export const LOGIN_INFO_KEY = 'LOGIN_INFO_KEY';
/** 版本信息 */
export const VERSION_RECORD_KEY = 'VERSION_RECORD_KEY';
